module.exports = __webpack_public_path__ + "img/conservative.cc59b795.png";